import uuid from "uuid/v4";
import moment from "moment";
import { forEach, findIndex } from "lodash";

export const createId = () => uuid();
export const updateObject = (oldObject, newValues) => {
  return { ...oldObject, ...newValues };
};

//RELATIVE TIME
export const getRelativeTime = date => {
  const localTime = moment.utc(date.toDate()).toDate();
  return moment(localTime).fromNow();
};
//RELATIVE TIME

//RELATIVE TIME
export const getFormattedTime = (date, format = "MM/DD/YYYY, h:mm a") => {
  const localTime = moment.utc(date).toDate();
  return moment(localTime).format(format);
};
//RELATIVE TIME

//GET CURRENT YEAR
export const getCurrentYear = (format = "YYYY") => {
  return moment().format(format);
};
//GET CURRENT YEAR

//CREATE TIMER
export const startTimer = (callback, time) =>
  setTimeout(() => {
    callback();
  }, +time);
//CREATE TIMER
//TOAST
const _defaultToastOptions = {
  type: "success",
  timeout: 5000
};
export const createToast = options => ({
  ..._defaultToastOptions,
  ...options,
  id: createId()
});
//TOAST

//MAP ARRAY TO OBJECT
export const mapArrayToObject = (array, keyId = "id") => {
  let object = {};

  forEach(array, item => {
    object[item[keyId]] = item;
  });
  return object;
};
//MAP ARRAY TO OBJECT
export const mapAddressFromGooglePlacesApiResponse = address => {
  if (!address) {
    return null;
  }
  //get formatted address
  const FORMATTED_ADDRESS = address.formatted_address;
  //get place id
  const PLACE_ID = address.place_id;

  //get lat and lng
  let LAT, LNG;
  try {
    LAT = address.geometry.location.lat();
    LNG = address.geometry.location.lng();
  } catch (error) {
    LAT = undefined;
    LNG = undefined;
  }

  //logic for getting all the information out of the address
  let floor,
    street_number,
    route,
    subLocality,
    locality,
    city,
    state,
    country,
    pincode;

  forEach(address.address_components, value => {
    //FLOOR
    if (findIndex(value.types, type => type === "floor") !== -1) {
      floor = { label: value.long_name, value: value.short_name };
    }
    //STREET NUMBER
    if (findIndex(value.types, type => type === "street_number") !== -1) {
      street_number = {
        label: value.long_name,
        value: value.short_name
      };
    }
    //ROUTE
    if (findIndex(value.types, type => type === "route") !== -1) {
      route = { label: value.long_name, value: value.short_name };
    }
    //SUB LOCALITY
    if (findIndex(value.types, type => type === "sublocality") !== -1) {
      subLocality = {
        label: value.long_name,
        value: value.short_name
      };
    }
    //LOCALITY
    if (findIndex(value.types, type => type === "locality") !== -1) {
      locality = { label: value.long_name, value: value.short_name };
    }
    //CITY
    if (
      findIndex(value.types, type => type === "administrative_area_level_2") !==
      -1
    ) {
      city = { label: value.long_name, value: value.short_name };
    }
    //STATE
    if (
      findIndex(value.types, type => type === "administrative_area_level_1") !==
      -1
    ) {
      state = { label: value.long_name, value: value.short_name };
    }
    //COUNTRY
    if (findIndex(value.types, type => type === "country") !== -1) {
      country = { label: value.long_name, value: value.short_name };
    }
    //PINCODE
    if (findIndex(value.types, type => type === "postal_code") !== -1) {
      pincode = { label: value.long_name, value: value.short_name };
    }
  });

  return {
    floor,
    street_number,
    route,
    subLocality,
    locality,
    city,
    state,
    country,
    pincode,
    formatted_address: FORMATTED_ADDRESS,
    place_id: PLACE_ID,
    lat: LAT,
    lng: LNG
  };
};

export const getAge = date => {
  return moment().diff(date, "years");
};

export const addPaddingZero = number => {
  if (!number) {
    return "None";
  } else if (number === 0) {
    return "None";
  } else if (number < 10) {
    return `0${number}`;
  } else {
    return number;
  }
};

// IS EMAIL
export const isEmail = email =>
  email.match(
    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  );
// IS EMAIL



// WEBPACK FOOTER //
// ./src/_utils/index.js